import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { GolfBag } from '../../api/models';

export type TABLE_TYPE = Table<GolfBag>;

export const TABLE = 'golfBag';
const SCHEMA = 'golfBagId, sortId';

class GolfBagDatabase implements DataRepository<GolfBag> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<GolfBag | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: GolfBag, key: Key): Promise<GolfBag> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: GolfBag[]): Promise<GolfBag[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<GolfBag[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const GolfBagDB = new GolfBagDatabase(db);
